export class KraWorkFlow {
    financialYearId:number;
    departmentId:number;
    roleTypeIds:number[]=[];
    currentUser:string
}
